import cssVariables from 'Constants/_variables.module.scss';

export const iconStyles = {
  root: {
    paddingRight: Number(cssVariables.iconPadding)
  }
};
